module.exports = __webpack_public_path__ + "static/media/kruhy.78f9cc87.png";